/*
 * Copyright (C) 2026 to Present Applause App Quality, Inc. All rights reserved.
 */

import { Injectable, Inject } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class StateStoreService {
  // Intentionally temporary: will be removed when routing migrates to Angular Router
  constructor(@Inject('$state') private $state: any) {}

  getState(item: any): { state: string; params: object } {
    if (!item.slug) {
      item.slug = item.id;
    }

    const typeStateMap: { [type: string]: { state: string; params: object } } = {
      article: { state: 'singlearticle', params: { articleId: item.slug } },
      course: { state: 'singlecourse', params: { courseId: item.slug } },
      tool: { state: 'singletool', params: { toolId: item.slug } },
      project: { state: 'singleproject', params: { projectId: item.slug } },
      topic: { state: 'singlediscussionpage', params: { page: 1, discussionId: item.slug } },
      user: { state: 'profile.about', params: { profileId: item.slug } },
      status: { state: 'singlestatus', params: { statusId: item.slug } },
    };

    return typeStateMap[item.type];
  }

  getHref(item: any): string {
    const stateObj = this.getState(item);
    return this.$state.href(stateObj.state, stateObj.params);
  }
}
